import { useIsEnabled, useLiveQuery } from "./_chunks-es/hooks.js";
import { lazy } from "react";
const LiveQueryProvider = lazy(
  () => import("./_chunks-es/LiveQueryProvider.js")
);
export {
  LiveQueryProvider,
  LiveQueryProvider as default,
  useIsEnabled,
  useLiveQuery
};
//# sourceMappingURL=index.js.map
